var $ = require('../../modules/$');
module.exports = function create(P, D){
  return $.create(P, D);
};


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/core-js/library/fn/object/create.js
// module id = 642
// module chunks = 0